//判断用户传入的类型 是否为数字类型
import {AssertUtils} from "goingutils";
import ColorSelCtl from "../jsCom/goForm/components/go-color-sel-ctl";
import GoAclWinCtl from "../jsCom/goForm/components/go-aclWin-ctl";
import DateCtl from "../jsCom/goForm/components/js-calendar";
import StaticDropCtl from "../jsCom/goForm/components/js-drop";
import CommonInputCtl from "../jsCom/goForm/components/js-input";
import TextAreaCtrl from "../jsCom/goForm/components/js-textArea";
import NumberInputCtl from "../jsCom/goForm/components/js-number";
import RadioBoxCtl from "../jsCom/goForm/components/js-radio";
import SwitchCtl from "../jsCom/goForm/components/go-switch";
import TreeDrop from "../jsCom/goForm/components/go-tree-drop";
import GridDrop from "../jsCom/goForm/components/go-grid-drop";
import HiddenCtl from "../jsCom/goForm/components/go-hidden-input";
import MultipleDropCtl from "../jsCom/goForm/components/go-multip-drop";
import PageDropCtl from "../jsCom/goForm/components/go-page-drop";
import WinDropCtl from "../jsCom/goForm/components/go-win-drop";
import LabelCtl from "../jsCom/goForm/components/go-label";
import typeFormUtils from "./typeFormUtils";


let CtlFactory = {
    getEditorType(item) {
        if (item == null) {
            return void 0;
        }
        if (!AssertUtils.isNotEmpty(item["editorType"]) && AssertUtils.isNotEmpty(item["type"])) {
            item["editorType"] = item["type"];
        }
        // 如果编辑类型还是为空 则设置成ro类型
        if (!AssertUtils.isNotEmpty(item["editorType"])) {
            item["editorType"] = "ro";
        }
        return item["editorType"];
    },
    ctlObj: [],
    //根据类型获取相应的控件对象
    getObj: function (editorType) {
        let object = null;
        if (typeFormUtils.isInputEl(editorType)) {
            object = (CtlFactory.ctlObj)["CommonInputCtl"];
        } else if (typeFormUtils.isDateEl(editorType)) {
            //如果是日期控件
            object = (CtlFactory.ctlObj)["DateCtl"];
        } else if (typeFormUtils.isNumber(editorType)) {
            //数字控件
            object = (CtlFactory.ctlObj)["NumberInputCtl"];
        } else if (typeFormUtils.isTreeDrop(editorType)) {
            //树下拉控件
            object = (CtlFactory.ctlObj)["TreeDrop"];
        } else if (typeFormUtils.isStaticDrop(editorType)) {
            //常规下拉控件
            object = (CtlFactory.ctlObj)["StaticDropCtl"];
        } else if (typeFormUtils.isColorSel(editorType)) {
            //常规下拉控件
            // object = (CtlFactory.ctlObj)['ColorSelCtl'];
        } else if (typeFormUtils.isMultipleDrop(editorType)) {
            //多选下拉控件
            object = (CtlFactory.ctlObj)["GoMultipDrop"];
        } else if (typeFormUtils.isPageDropEl(editorType)) {
            object = (CtlFactory.ctlObj)["CommonInputCtl"];
        } else if (typeFormUtils.isWinObjEl(editorType)) {
            object = (CtlFactory.ctlObj)["CommonInputCtl"];
        } else if (typeFormUtils.isBooleanEl(editorType)) {
            object = (CtlFactory.ctlObj)["CommonInputCtl"];
        } else if (typeFormUtils.isTextArea(editorType)) {
            object = (CtlFactory.ctlObj)["TextAreaCtrl"];
        } else if (typeFormUtils.isAclEl(editorType)) {
            //选人授权组件
            object = (CtlFactory.ctlObj)["AclWinCtl"];
        } else if (typeFormUtils.isRadioBox(editorType)) {
            //RadioBoxCtl控件
            object = (CtlFactory.ctlObj)["RadioBoxCtl"];
        } else if (typeFormUtils.isSwitchEl(editorType)) {
            object = (CtlFactory.ctlObj)["SwitchCtl"];
        } else if (typeFormUtils.isHiddenEl(editorType)) {
            object = (CtlFactory.ctlObj)["HiddenCtl"];
        } else if (typeFormUtils.isGridDrop(editorType)) {
            object = (CtlFactory.ctlObj)["GridDrop"];
        } else if (typeFormUtils.isWinDrop(editorType)) {
            object = (CtlFactory.ctlObj)["WinDropCtl"];
        } else if (typeFormUtils.isLabel(editorType)) {
            object = (CtlFactory.ctlObj)["LabelCtl"];
        } else {
            object = (CtlFactory.ctlObj)["CommonInputCtl"];
        }
        return object;
    },
    initCtlEvent: function (
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        //初始化控件的交互和事件信息
        for (let propName in this.ctlObj) {

            this.ctlObj[propName].initCtlEvent(
                parentObj,
                inputWidth,
                targetObj,
                vueObj
            );
        }
    },
    //将控件注册进工厂类
    addCtl(ctlName, _ctlObj) {
        this.ctlObj[ctlName] = _ctlObj;
    }
};

function _isNumberType(dataType) {
    if ("int" === dataType || "float" === dataType || "double" === dataType) {
        return true;
    } else {
        return false;
    }
}

export function getEditorType(item) {
    if (item == null) {
        return void 0;
    }

    //如果用户定义了编辑类型 则以用户定义的编辑类型为准 如果未定义编辑类型就以用户定义的type为准
    if (!AssertUtils.isNotEmpty(item["editorType"])) {
        item["editorType"] = item["type"];
        //如果用户定义了dataType类型 则根据数字类型进行匹配
        if (
            AssertUtils.isNotEmpty(item["dataType"]) &&
            _isNumberType(item["dataType"])
        ) {
            item["editorType"] = "number";
        }
    }
    let {editorType = "ro"} = item;
    return editorType;
}

//编辑类型工具类
let EditorTypeUtils = {
    //获取编辑类型
    getEditorType(item) {
        return CtlFactory.getEditorType(item);
    },
    //获取编辑对象
    getObj(editorType) {
        //如果组件都是空 则需要初始化下 工厂才行
        if(CtlFactory.ctlObj.length===0){
            //需要初始化表单才行
            EditorTypeUtils.initGoForm();
        }
        return CtlFactory.getObj(editorType);
    },
    //初始化goForm对象
    initGoForm() {
        //如果没有初始化过 则需要初始化 初始化完了则不需要重复初始化
        if (CtlFactory.getObj("CommonInputCtl") == null) {
            CtlFactory.addCtl("ColorSelCtl", ColorSelCtl);
            CtlFactory.addCtl("AclWinCtl", GoAclWinCtl);
            CtlFactory.addCtl("DateCtl", DateCtl);
            CtlFactory.addCtl("StaticDropCtl", StaticDropCtl);
            CtlFactory.addCtl("CommonInputCtl", CommonInputCtl);
            CtlFactory.addCtl("TextAreaCtrl", TextAreaCtrl);
            CtlFactory.addCtl("NumberInputCtl", NumberInputCtl);
            CtlFactory.addCtl("RadioBoxCtl", RadioBoxCtl);
            CtlFactory.addCtl("SwitchCtl", SwitchCtl);
            CtlFactory.addCtl("TreeDrop", TreeDrop);
            CtlFactory.addCtl("GridDrop", GridDrop);
            CtlFactory.addCtl("HiddenCtl", HiddenCtl);
            CtlFactory.addCtl("MultipleDropCtl", MultipleDropCtl);
            CtlFactory.addCtl("PageDropCtl", PageDropCtl);
            CtlFactory.addCtl("WinDropCtl", WinDropCtl);
            CtlFactory.addCtl("LabelCtl", LabelCtl);
        }
    },
    //根据查询ary，转换成 查询的ary
    getQueryAry(oldQueryAry) {
        let newQueryAry = [];
        oldQueryAry.map(function (oldItem) {
            let item = {...oldItem};
            if(item.id==='empty'){
                return;
            }
            if (item["query"] !== false) {
                //设置为可以编辑
                item["disabled"] = false;
                //清空初始值
                item["defVal"] = "";
                //如果是switch控件 需要转换下
                if (item["editorType"] === "switch") {
                    item["editorType"] = "staticDrop";
                }
                //如果是radiobox
                if (item["editorType"] === "radioBox") {
                    item["editorType"] = "staticDrop";
                }
                item["treeRelVal"] = "";
                //如果配置了单元格占用数量 而且占用宽度大于1
                if (item["cellCount"] != null && item["cellCount"] > 1) {
                    newQueryAry.push(item);
                    for (let num = 0; num < item["cellCount"] - 1; num++) {
                        newQueryAry.push({type: "slot", fieldId: item["id"]});
                    }
                } else {
                    newQueryAry.push(item);
                }
            }
        });
        return newQueryAry;
    },
    loadDataByJson(jsonObj, targetObj) {
        for (let prop in jsonObj) {
            let item = (EditorTypeUtils.itemTemp)[
                `${targetObj.prefixCls}_${prop}`
                ];
            //如果不为空 才继续执行
            if (AssertUtils.isNotNull(item)) {
                let editorType = getEditorType(item);
                let object = CtlFactory.getObj(editorType);
                if (object != null) {
                    object.setValue(prop, jsonObj[prop], item, targetObj, jsonObj);
                }
            }
        }
    },
    setEditorState(organizationDomain, elAry, state) {
        if (!state) {
            organizationDomain.forEach(function (item) {
                elAry.forEach(function (itemId) {
                    if (item["id"] === itemId) {
                        item["editor"] = false;
                    }
                });
            });
        }
    },
    itemTemp: {},
    //初始化控件 根据类名称
    initGoCtlByClass(
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        CtlFactory.initCtlEvent(parentObj, inputWidth, targetObj, vueObj);
    },
    /**
     * 根据item的类型来初始化控件
     * @param item
     * @param parentObj
     * @param inputWidth
     * @param targetObj
     */
    initCtlByItemType(
        item,
        parentObj,
        inputWidth,
        targetObj
    ) {
        let editorType = getEditorType(item);
        let object = CtlFactory.getObj(editorType);
        if (object != null) {
            object.initCtlEvent(parentObj, inputWidth, targetObj);
        }
    },
    /**
     * 根据编辑类型 获取对应填入的值
     * @param item
     * @param backJson
     * @param formType
     * @param targetObj
     */
    getSubmitDataByItem(item, backJson, formType, targetObj) {
        let editorType = getEditorType(item);
        let object = CtlFactory.getObj(editorType);
        if (object != null) {
            object.getSubmitData(item, targetObj, backJson, formType);
        }
    },
    /**
     * 清空数据
     * @param item
     * @param formType
     * @param targetObj
     */
    clearData(item, formType, targetObj) {
        let editorType = getEditorType(item);
        let object = CtlFactory.getObj(editorType);
        if (object != null) {
            object.clearData(item, formType, targetObj);
        }
    },
    /**
     * 根据编辑类型 获取该字段对应的html片断
     * @param item
     * @param formType
     * @param targetObj
     */
    getItemHtmlByType(item, formType, targetObj) {
        let editorType = getEditorType(item);
        EditorTypeUtils.itemTemp[`${targetObj.prefixCls}_${item["id"]}`] = item;
        let object = CtlFactory.getObj(editorType);
        if (object != null) {
            //有可能设置的不是maxlength 所以转化下
            if(parseFloat(item["maxLength"])>0){
                item["maxlength"]=item["maxLength"];
            }
            return object.getHtml(formType, item, targetObj);
        }
    }
};

export default EditorTypeUtils;



// WEBPACK FOOTER //
// ./goingsrc/common/editorTypeUtils.js